<template>
  <div v-if="isVisibleFilters">
    <v-chip
      v-for="chip in chips"
      :key="chip.value"
      :value="chip.value"
      :color="chip.isActive ? 'primary' : 'bg-primary'"
      :text-color="chip.isActive ? 'bg-gray-0' : 'primary'"
      class="mr-2"
      @click="handleClickFilter(chip)"
    >
      {{ chip.text }} ({{ chip.amount }})
    </v-chip>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { ChipFilter } from 'www/vue_components/common/ReviewsFilter/types'

type Emits = {
  (e: 'change:filter-chip', chip: ChipFilter): void // eslint-disable-line
}

const emit = defineEmits<Emits>()

const props = withDefaults(defineProps<{ chips: ChipFilter[] }>(), { chips: () => [] })
const isVisibleFilters = computed(() => props.chips.every(chip => chip.amount))

function handleClickFilter(chip: ChipFilter) {
  emit('change:filter-chip', chip)
}
</script>
